document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('.gm-carousel').forEach(function (carousel) {
    
    // Wrap original slides in container
    let container = document.createElement('div');
    container.className = 'gm-slide-container';

    let slides = Array.from(carousel.children);
    slides.forEach(s => {
      s.classList.add('gm-slide-wrapper');
      container.appendChild(s);
    });

    carousel.innerHTML = '';
    carousel.appendChild(container);

    let index = 0;
    let autoplaySpeed = 3000;  
    let autoplayTimer;
    let isHovering = false;

    function slidesVisible() {
      let w = window.innerWidth;
      if (w <= 520) return 1;
      if (w <= 900) return 2;
      return 4;  
    }

    function update() {
      let visible = slidesVisible();
      let slideWidth = container.children[0].getBoundingClientRect().width;
      let gap = parseFloat(getComputedStyle(container).gap) || 12;

      container.style.transform = `translateX(${-(slideWidth + gap) * index}px)`;

      // Highlight active slide
      Array.from(container.children).forEach((el, i) => {
        el.classList.toggle("gm-active", i === index);
      });
    }

    // Infinite loop logic
    function nextSlide() {
      let visible = slidesVisible();
      index++;

      if (index > container.children.length - visible) {
        index = 0;
      }
      update();
    }

    function prevSlide() {
      let visible = slidesVisible();
      index--;

      if (index < 0) {
        index = container.children.length - visible;
      }
      update();
    }

    // Buttons
    let parent = carousel.parentElement;
    let prev = parent.querySelector('.gm-prev');
    let next = parent.querySelector('.gm-next');

    if (prev) prev.addEventListener('click', prevSlide);
    if (next) next.addEventListener('click', nextSlide);

    // Autoplay
    function startAutoplay() {
      autoplayTimer = setInterval(() => {
        if (!isHovering) nextSlide();
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      clearInterval(autoplayTimer);
    }

    carousel.addEventListener("mouseenter", () => {
      isHovering = true;
    });

    carousel.addEventListener("mouseleave", () => {
      isHovering = false;
    });

    // Swipe Support (Mobile)
    let startX = 0;
    let dragging = false;

    carousel.addEventListener("touchstart", (e) => {
      dragging = true;
      startX = e.touches[0].clientX;
      stopAutoplay();
    });

    carousel.addEventListener("touchmove", (e) => {
      if (!dragging) return;
      let diff = e.touches[0].clientX - startX;
      if (diff > 50) {
        dragging = false;
        prevSlide();
      } else if (diff < -50) {
        dragging = false;
        nextSlide();
      }
    });

    carousel.addEventListener("touchend", () => {
      dragging = false;
      startAutoplay();
    });

    // Desktop drag
    carousel.addEventListener("mousedown", (e) => {
      dragging = true;
      startX = e.clientX;
      stopAutoplay();
    });

    carousel.addEventListener("mouseup", (e) => {
      if (!dragging) return;
      let diff = e.clientX - startX;
      if (diff > 50) prevSlide();
      else if (diff < -50) nextSlide();
      dragging = false;
      startAutoplay();
    });

    window.addEventListener('resize', update);

    setTimeout(update, 80);
    startAutoplay();

  });

});
